import { render, staticRenderFns } from "./TelephoneField.vue?vue&type=template&id=4f024227&scoped=true"
import script from "./TelephoneField.vue?vue&type=script&lang=js"
export * from "./TelephoneField.vue?vue&type=script&lang=js"
import style0 from "./TelephoneField.vue?vue&type=style&index=0&id=4f024227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f024227",
  null
  
)

export default component.exports